module.exports = require("script-ext-html-webpack-plugin");